export const VideoUploadStatus = Object.freeze({
    UPLOADING: 'uploading',
    SUCCESS: 'success',
    FAILED: 'failed',
    CANCELLING: 'cancelling',
    CLOSED: 'closed',
});

export const VideoStepAdditionalTextType = Object.freeze({
    WAITING_FOR_APPROVAL: 'waiting_for_approval',
    IN_PROGRESS: 'in_progress',
});

export const StoreCancellUploadingEventName = 'videoUploading/handleCancelling';